<div class="detail">
  <h1>Vyhledávání</h1>

  <fieldset>
    <div class="mb-5">
      <search-filter-item *ngFor="let filter of filters;" [filter]="filter" [type]="'selected'" (removed)="onRemoveFilter($event)"></search-filter-item>
    </div>

    <div class="column-100 flexbox-container flex-vertical-centered">
      <div class="search-input-wrapper">
        <input #searchInput class="fulltext" name="search" type="text" autocomplete="off" placeholder="Fulltextové hledání ..." [(ngModel)]="query" (keyup.enter)="query && onSearch()"/>
        <button *ngIf="query" class="search-input-clear" type="button" (click)="onClear()" title="Smazat">&times;</button>
      </div>
      <gmt-button [clickAction]="onSearch" [gmtDisabled]="!query || query.trim().length < 1" class="filter-submit">Filtrovat</gmt-button>
    </div>

  </fieldset>

  <div *ngIf="list" class="mt-10 tabbable-line tabs-below">
    <ul class="nav nav-tabs">
      <li *ngFor="let category of categories" class="nav-item" [ngClass]="{ active: category.active }" (click)="onChangeCategory(category)">
        <a class="nav-link" [ngClass]="{ active: category.active }"><i *ngIf="category.icon" class="mr-4 tab-icon" [ngClass]="category.icon"></i>{{ category.name }} ({{ category.cachedCount > 10000 ? '10000+' : category.cachedCount }})
        </a>
      </li>
    </ul>
    <div [loading]="list.loading" class="tab-content">
      <div *ngIf="!list.loading && list.itemCount">
        <div class="table-top-container mt-10" *ngIf="list.itemCount">
          <itemscounter *ngIf="list.itemCount" [list]="list" (callbackRegister)="itemCounterCallbackRegister($event)" class="flex-start"></itemscounter>
          <pagescounter *ngIf="list.itemCount" [list]="list" (callbackRegister)="pagesCounterCallbackRegister($event)" class="flex1 pagescounter-container" ></pagescounter>
          <div class="page-count-select">
            <span>Záznamů na stránce</span>
            <gmt-select
              required="true"
              [data]="dataPaging"
              field="itemsPerPage"
              [optionItems]="itemsPerPage"
              class="min-width-unset"
              (changed)="onPageItemsChanged()"
            ></gmt-select>
          </div>
        </div>
        <div *ngFor="let result of list.list">
          <search-result [result]="result" type="l"></search-result>
        </div>
        <div class="mt-10">
          <pagination *ngIf="list.itemCount" [shouldUpdateUrl]="false" [list]="list" (pageChanged)="onPageChanged($event)" (callbackRegister)="paginationCallbackRegister($event)"></pagination>
        </div>
      </div>

      <div *ngIf="!list.loading && !list.itemCount" class="jumbotron text-center mt-10">
        Pro zadaný dotaz nebyly nalezeny žádné výsledky.
      </div>

    </div>
  </div>

  <help [helpId]="helpIds.SEARCH_FULL" class="cm-help-page"></help>
</div>
